export const AMENITIES = [
  { key: "wifi", label: "Wi-Fi" },
  { key: "kitchen", label: "Kitchen" },
  { key: "washer", label: "Washing machine" },
  { key: "ac", label: "Air conditioning" },
  { key: "heating", label: "Heating" },
  { key: "tv", label: "TV" },
  { key: "workspace", label: "Workspace" },
  { key: "parking", label: "Free parking" },
  { key: "pool", label: "Pool" },
  { key: "hot_tub", label: "Hot tub" },
  { key: "balcony", label: "Balcony / terrace" },
  { key: "elevator", label: "Elevator" },
  { key: "fireplace", label: "Fireplace" },
  // Greece-relevant
  { key: "sea_view", label: "Sea view" },
  { key: "mountain_view", label: "Mountain view" },
  { key: "lake_view", label: "Lake view" },
  { key: "garden", label: "Garden" },
  { key: "bbq", label: "BBQ / outdoor grill" },
  { key: "beach_access", label: "Beach access" },
  { key: "dishwasher", label: "Dishwasher" },
  { key: "smoke_alarm", label: "Smoke alarm" },
  { key: "first_aid", label: "First-aid kit" },
  { key: "crib", label: "Crib" },
  { key: "high_chair", label: "High chair" },
  { key: "wheelchair_accessible", label: "Wheelchair accessible" },
  { key: "self_checkin", label: "Self check-in" },
] as const;

export const AMENITY_LABELS: Record<string, string> = Object.fromEntries(
  AMENITIES.map((a) => [a.key, a.label]),
);

export function amenityLabel(key: string): string {
  return AMENITY_LABELS[key] ?? key.replace(/_/g, " ");
}
